"use client"

import { usePathname } from "next/navigation"

import { routes } from "@/constants/routes"
import { isNavItemActive } from "@/features/navigation"
import { useNavbarSearchStore } from "@/stores/navbar-search"

import { ItemButton, ItemLink } from "./ListItem"
import { texts } from "./localization/texts"
import { NavbarSurface } from "./NavbarSurface"

export type Props = {
  isAuthed: boolean
}

function resolveUserItem(isAuthed: boolean) {
  return isAuthed
    ? { href: routes.DASHBOARD, title: texts.profile }
    : { href: routes.LOGIN, title: texts.login }
}

export function Navbar({ isAuthed }: Props) {
  const pathname = usePathname() ?? ""
  const lastItem = resolveUserItem(isAuthed)
  const searchOpen = useNavbarSearchStore((state) => state.open)
  const toggleSearch = useNavbarSearchStore((state) => state.toggle)

  return (
    <div
      data-betby-bottom-nav
      className="fixed z-120 inset-x-0 bottom-2 ls:hidden mx-3 overflow-visible"
    >
      <nav className="relative w-full h-[65px] overflow-visible">
        <NavbarSurface />
        <ul className="relative flex items-center justify-between gap-6 px-6 h-full overflow-visible">
          <li className="overflow-visible">
            <ItemLink
              href={routes.HOME}
              name="menu"
              title={texts.menu}
              isActive={isNavItemActive(pathname, routes.HOME)}
            />
          </li>
          <li className="overflow-visible">
            <ItemLink
              href={routes.CASINO}
              name="casino"
              title={texts.casino}
              isActive={isNavItemActive(pathname, routes.CASINO)}
            />
          </li>
          <li className="overflow-visible">
            <ItemButton
              name="search"
              title={texts.search}
              className="justify-end pt-7"
              iconClassName="size-12 absolute -top-3"
              pressed={searchOpen}
              onClick={toggleSearch}
            />
          </li>
          <li className="overflow-visible">
            <ItemLink
              href={routes.SPORTS}
              name="sports"
              title={texts.sports}
              isActive={isNavItemActive(pathname, routes.SPORTS)}
            />
          </li>
          <li className="overflow-visible">
            <ItemLink
              href={lastItem.href}
              name="user"
              title={lastItem.title}
              isActive={isNavItemActive(pathname, lastItem.href)}
            />
          </li>
        </ul>
      </nav>
    </div>
  )
}
